import React, { PropTypes } from 'react';
import { Link } from 'react-router';

function BottomNavigation({ previousLink, previousText, nextLink, nextText }) {

  return (
    <footer className="page-footer bottom-navigation">
      <div className="container">
        <div className="row valign-wrapper no-bottom">

          <div className="col s6 m6 l6 left-align" hidden={previousLink}/>

          <div className="col s1 m1 l1 left-align" hidden={!previousLink}>
            <Link to={previousLink}>
              <i className="material-icons bottom-valign">arrow_back</i>
            </Link>
          </div>
          <div className="col s5 m5 l5 left-align" hidden={!previousLink}>
            <p>
              <Link to={previousLink}>
                <span className="previous-next-small">Précédent</span><br/>
                <span className="previous-next-big">{previousText}</span>
              </Link>
            </p>
          </div>

          <div className="col s6 m6 l6 left-align" hidden={nextLink}/>

          <div className="col s5 m5 l5 right-align" hidden={!nextLink}>
            <p>
              <Link to={nextLink}>
                <span className="previous-next-small">Suivant</span><br/>
                <span className="previous-next-big">{nextText}</span>
              </Link>
            </p>
          </div>
          <div className="col s1 m1 l1 right-align" hidden={!nextLink}>
            <Link to={nextLink}>
              <i className="material-icons bottom-valign">arrow_forward</i>
            </Link>
          </div>

        </div>
      </div>

    </footer>
  );
}

const { string } = PropTypes
BottomNavigation.propTypes = {
  previousText: string,
  previousLink: string,
  nextText: string,
  nextLink: string
};

export default BottomNavigation;



/** WEBPACK FOOTER **
 ** ./src/components/BottomNavigation.js
 **/